<template>
  <iframe
    :src="video"
    ref="player"
    allow="autoplay; encrypted-media; fullscreen; picture-in-picture;"
    frameborder="0"
    allowfullscreen
  />
</template>

<script>
export default {
  name: 'VkVideoPlayer',
  props: {
    src: String,
  },
  computed: {
    video() {
      const url = new URL(this.src)
      const [, videoParams] = url.pathname.split('/video')
      if (!videoParams) return this.src
      const [oid, id] = videoParams.split('_')
      return `https://vk.com/video_ext.php?oid=${oid}&id=${id}&hd=2&js_api=1`
    },
  },
  methods: {
    listenState() {
      const state = this.player.getState()
      switch (state) {
        case 'playing':
          this.$emit('play', true)
          return
        case 'paused':
        case 'ended':
          this.$emit('play', false)
          return
      }
    },
  },
  data() {
    return {
      player: null,
    }
  },
  mounted() {
    this.player = window.VK.VideoPlayer(this.$refs.player)

    this.player.on('started', this.listenState)
    this.player.on('resumed', this.listenState)
    this.player.on('paused', this.listenState)
    this.player.on('ended', this.listenState)
  },
  unmounted() {
    this.player.off('started', this.listenState)
    this.player.off('resumed', this.listenState)
    this.player.off('paused', this.listenState)
    this.player.off('ended', this.listenState)
  },
}
</script>
